/* Hidden carousel slides (aria-hidden="true") must not hold keyboard focus (Lighthouse aria-hidden-focus).
   Takes their links and buttons out of the tab order while hidden and puts them back when shown. */
(function () {
  var SEL = 'a[href],button,input,select,textarea,[tabindex]';
  function sync(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    slide.querySelectorAll(SEL).forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-sj-tab')) el.setAttribute('data-sj-tab', el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-sj-tab')) {
        var t = el.getAttribute('data-sj-tab');
        if (t) el.setAttribute('tabindex', t); else el.removeAttribute('tabindex');
        el.removeAttribute('data-sj-tab');
      }
    });
  }
  function init() {
    var slides = document.querySelectorAll('.swiper-slide,[class*="slide"][aria-hidden]');
    if (!slides.length) return;
    var mo = new MutationObserver(function (list) { list.forEach(function (m) { sync(m.target); }); });
    slides.forEach(function (s) { sync(s); mo.observe(s, { attributes: true, attributeFilter: ['aria-hidden'] }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Search panel (2026-10-22): recent searches in this visitor's browser (Angara), and Enter on an exact category name
   opens that collection (Blue Nile lands category searches on the category page). Results page: "1,000+ results". */
(function () {
  var KEY = 'sj-recent-searches', MAX = 6;
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function remember(q) {
    q = (q || '').trim(); if (q.length < 2) return;
    var list = read().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q); write(list.slice(0, MAX));
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fill() {
    document.querySelectorAll('[data-sj-recent]').forEach(function (box) {
      var list = read(); box.hidden = !list.length;
      var ul = box.querySelector('ul'); if (!ul) return;
      var html = list.map(function (q) { return '<li><a href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last" data-sj-term="' + esc(q) + '">' + esc(q) + '</a></li>'; }).join('');
      if (ul.innerHTML !== html) ul.innerHTML = html;
    });
  }
  /* "Men's Rings" / "mens ring" / "Rings" all compare equal */
  function norm(s) {
    return String(s || '').toLowerCase().replace(/&/g, ' and ').replace(/['’]/g, '').replace(/[^a-z0-9 ]+/g, ' ')
      .replace(/\s+/g, ' ').trim().replace(/s\b/g, '');
  }
  var MAIN = { 'ring': '/collections/rings', 'earring': '/collections/earrings', 'necklace': '/collections/necklaces-chains',
    'necklace and chain': '/collections/necklaces-chains', 'chain': '/collections/necklaces-chains', 'pendant': '/collections/charms-pendants',
    'charm': '/collections/charms-pendants', 'pendant and charm': '/collections/charms-pendants', 'bracelet': '/collections/bracelets',
    'engagement ring': '/collections/engagement-rings', 'wedding ring': '/collections/wedding-rings', 'wedding band': '/collections/wedding-rings',
    'men ring': '/collections/mens-rings', 'men jewelry': '/collections/mens-jewelry', 'gift': '/collections/gifts',
    'lab grown diamond': '/collections/lab-grown-diamonds', 'christma gift': '/collections/christmas-gifts' };
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[action$="/search"]')) return;
    var input = f.querySelector('input[name="q"]'); var q = input ? input.value : '';
    remember(q);
    var n = norm(q), dest = MAIN[n];
    if (!dest) {
      var hit = Array.prototype.find.call(document.querySelectorAll('[data-sj-coll]'), function (a) { return norm(a.getAttribute('data-sj-coll')) === n; });
      if (hit) dest = hit.getAttribute('href');
    }
    if (dest) { e.preventDefault(); e.stopPropagation(); location.href = dest; }
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sj-term]');
    if (t) remember(t.getAttribute('data-sj-term'));
    var c = e.target.closest && e.target.closest('[data-sj-recent-clear]');
    if (c) { e.preventDefault(); write([]); fill(); }
  });
  function capped() {
    if (location.pathname.indexOf('/search') !== 0 && !document.querySelector('.sjt-inpage-grid')) return;
    document.querySelectorAll('#ProductCount, #ProductCountMobile, .template-search__header p, .product-count, .product-count__text, .results-count').forEach(function (el) {
      if (el.children.length === 0 && /^\s*1000 results/.test(el.textContent)) el.textContent = el.textContent.replace('1000 results', '1,000+ results');
      /* "1002 results" -> "1,002 results" */
      if (el.children.length === 0 && /^\s*\d{4,} results/.test(el.textContent)) el.textContent = el.textContent.replace(/\d{4,}/, function (n) { return Number(n).toLocaleString('en-US'); });
    });
    document.querySelectorAll('.pagination-wrapper *').forEach(function (el) {
      if (el.children.length === 0 && /\bof 1000 products/.test(el.textContent)) el.textContent = el.textContent.replace('of 1000 products', 'of 1,000+ products');
    });
  }
  var queued = false;
  new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; fill(); capped(); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fill(); capped(); }); else { fill(); capped(); }
})();
